import './ProgressBar.scss';
import ProgressActive from '../../../images/progress-bar-active.png';
import ProgressInactive from '../../../images/progress-bar-inactive.png';

export const ProgressBar = ({ pageNo, totalPages = 2 }) => {
  const renderProgressBars = () => {
    const bars = [];
    for (let i = 1; i <= totalPages; i++) {
      bars.push(<img key={i} src={pageNo === i ? ProgressActive : ProgressInactive} alt={`progress-bar-${i}`} />);
    }
    return bars;
  };

  return <div className="progress-bar">{renderProgressBars()}</div>;
};
